import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import { DomSanitizer, SafeResourceUrl, SafeUrl, SafeHtml } from '@angular/platform-browser';

import { NetworkHelperService } from '../../../_services/network-helper.service';
import {FORMS, API, CODFUNC, GENERALES, PAGE} from '../../../_config/strings';
import {Usuario} from '../../../_model/Usuario';
import { Cliente } from '../../../_model/Cliente';
import Swal from 'sweetalert2';
import { IMyDpOptions, MyDatePicker, MyDatePickerModule } from 'mydatepicker';
import * as moment from 'moment';
import { ChatService } from '../../../_services/chat.service';

// variable utilizada en JQuery para poder obtener los documentos y utilizar For en el recorrido
declare var $: any;

@Component({
  selector: 'app-registrar-abastecimiento',
  templateUrl: './registrar-abastecimiento.component.html',
  styleUrls: ['./registrar-abastecimiento.component.scss']
})

export class RegistrarAbastecimientoComponent implements OnInit {

    FORMS: any;
    API: any;
    GENERALES: any;
    PAGE: any;
    public usuario: Usuario = new Usuario();
    public cliente: Cliente = new Cliente();
    public innerHtml: SafeHtml;
    public innerHtmlContrato: SafeHtml;

    sucursalesUsuaio = [];
    arrayCotizaciones = [];
    loginLoader = false;

    urlContrato = '';
    idCliente: any;
    urlProrroga = '';
    inputContrato = false;

    // Cotización
    cotizacionId;
    cotizacionNombre;
    // Cotización

    // Contrato
    iconoFormaContrato = '';
    iconoColorContrato = '';
    mostrarContrato = '';
    contratoRuta = '';
    contratoEstatusEstatus = '';
    tipoContrato: string;
    contratoEstatusNombre = '';
    abastecimientoId;
    // Contrato

    // Campos faltantes
    fFolioContrato = false;
    vistaNombreCliente;
    vistaCotizacionCliente;
    vistaCotizacionDescripcion;
    vistaCotizacionObra;
    vistaCotizacionUsuario;
    // Campos faltantes

    nombre = '';
    duracionServicio;
    nombreCompleto = '';
    nombreC = '';
    paternoC = '';
    maternoC = '';
    rfc = '';
    tipoCliente = '';
    tipoClienteEnFormulario = '';
    razonSocial = '';

    concepto = '';
    urlCompleta;
    arrayUrl;
    conceptoSpli = '';
    ordenTrabajoDocumento = '';
    contratoFolio = '';
    contradoDescripcion = '';
    nombreObra = '';
    llenarContrato = 'Contrato Llenado';
    folioDeContrato = '';

    // Calendario Inicio
    fechaDeInicio = '';
    public myDatePickerOptions: IMyDpOptions = {
        dateFormat: 'yyyy/mm/dd',
        markCurrentDay: true,
        markCurrentMonth: true,
    };

    // Fechas
    fechaEnDataPicker = '';
    nuevaFecha: any;

    constructor(
        private route: ActivatedRoute,
        private network: NetworkHelperService,
        private ruta: Router,
        private chat: ChatService,
        private sanitizer: DomSanitizer
    ) {
        this.idCliente = this.route.snapshot.paramMap.get('id');
        this.FORMS = FORMS;
        this.API = API;
        this.GENERALES = GENERALES;
        this.PAGE = PAGE;
        this.urlCompleta = this.ruta.url;
        this.urlProrroga = this.urlCompleta.split('/')[7] ;
        this.usuario = JSON.parse( localStorage.getItem('usuario') );
        this.route.params.take(1).subscribe((params: any) => {
            this.urlContrato = params['idContrato'];
        });
    }

    ngOnInit() {
        this.getCliente();
        this.detallesContrato();
        this.contratoTipo();
        this.cotizacionesAceptadas();

        $('.folioDelContrato').on('input', function (e) {
            if (!/^[a-z0-9áéíóúüñ@.,-_/]*$/i.test(this.value)) {
                // [ a-z0-9áéíóúüñ]
                this.value = this.value.replace(/[^a-z0-9áéíóúüñ@.,-_/]+/ig, '');
            }
        });

        $('#fContrato').click(function() {
            alert('The paragraph was clicked.');
        });
    }

    detallesContrato () {
        this.network.callSecureService(
            this.API.user.clientes + '/' + this.idCliente + '/' + this.API.user.contratos + '/' + this.urlContrato,
            'GET',
            null )
            .subscribe((response: any) => {
                // console.log(response);
                if (response.Estatus === 200) {
                    this.contratoEstatusNombre = response.Mensaje.noContrato.estatus.nombre;
                    this.contratoEstatusEstatus = response.Mensaje.noContrato.estatus.estatus;
                    this.contratoRuta = response.Mensaje.noContrato.ruta;
                    this.contratoFolio = response.Mensaje.noContrato.noContrato;
                    this.mostrarContrato = this.API.contratos + this.contratoRuta;
                    // Realizados split a la ruta del contrato para compararlo y modificar el PupUp.
                    let tipo;
                    tipo = this.mostrarContrato.split('.');
                    this.tipoContrato = tipo[tipo.length -1];
                    this.setInnerHtml(this.mostrarContrato);
                    // Switch
                    switch (this.contratoEstatusEstatus) {
                        // Autorizado
                        case 'AUTCOMP': {
                            this.iconoFormaContrato = 'mdi mdi-checkbox-multiple-marked-circle';
                            this.iconoColorContrato = 'springgreen';
                            break;
                        }
                        // Pendiente por revisar
                        case 'AUTPEND': {
                            this.iconoFormaContrato = 'mdi mdi-alert-box';
                            this.iconoColorContrato = 'orange';
                            break;
                        }
                        // Autorización denegada
                        case 'AUTDENE': {
                            this.iconoFormaContrato = 'mdi mdi-close-box';
                            this.iconoColorContrato = 'red';
                            break;
                        }
                        // Sin documento
                        case 'NOTEXIS': {
                            this.iconoFormaContrato = 'mdi mdi-close-outline';
                            this.iconoColorContrato = 'black';
                            break;
                        }
                        case 'PREAUT': {
                            this.iconoFormaContrato = 'mdi mdi-file-powerpoint';
                            this.iconoColorContrato = 'brown';
                            break;
                        }
                        default:
                        // console.log( 'No entró en ningún estatus' );
                    }
                    // Switch
                    /*
                    if (this.contratoEstatusEstatus === 'AUTPREE' || this.contratoEstatusEstatus === 'AUTCOMP' || this.contratoEstatusEstatus === 'AUTSINF') {
                        this.btnRegistrarContrato = false;
                    } else {
                        this.btnRegistrarContrato = true;
                    }
                    */
                    // this.iconoFormaContrato = 'mdi mdi-checkbox-multiple-marked-circle';
                    // this.iconoColorContrato = 'springgreen';
                    this.alquilerReabastecimiento();
                } else {
                    // Swal('Oops', 'ocurrió un error', 'warning');
                }
                // this.detallesCliente = [];
            }, err => {
                console.log(err);
                Swal('Error ' + err.error.error.code, err.error.error.exception[0].message, 'error');
            }
        );
    }

    cotizacionesAceptadas() {
        this.network.callSecureService(
            this.API.user.orden + '/' + this.API.user.cotizacion + '/' + this.API.user.aceptada + '/' + this.API.user.listar,
            'GET',
            null )
            .subscribe((response: any) => {
                console.log(response);
                const cotizaciones = response.Mensaje;
                if (response.Estatus === 200) {
                    for (const coti of cotizaciones[0]) {
                        this.arrayCotizaciones.push({
                            id: coti.id,
                            nombre: coti.clienteCotizado,
                            descripcion: coti.descripcion,
                            obra: coti.obraCotizada,
                            usuario: coti.usuario,
                            contacto: coti.contacto,
                            email: coti.email,
                        });
                        this.cotizacionNombre = coti.clienteCotizado;
                    }
                }
            }, err => {
                console.log(err);
                Swal('Error ' + err.error.error.code, err.error.error.exception[0].message, 'error');
            }
        );
    }

    idCoti() {
        this.vistaNombreCliente = this.arrayCotizaciones.find(dato => dato.id === Number(this.cotizacionId));
        this.vistaCotizacionObra = this.vistaNombreCliente.obra;
        this.vistaCotizacionDescripcion = this.vistaNombreCliente.descripcion;
        this.vistaCotizacionCliente = this.vistaNombreCliente.nombre;
        this.vistaCotizacionUsuario = this.vistaNombreCliente.usuario;
    }

    alquilerReabastecimiento () {
        if ( this.urlProrroga === 'reabastecimiento' ) {
            this.inputContrato = false;
        } else {
            this.inputContrato = true;
            this.urlProrroga = 'alquiler';
        }
    }

    contratoTipo () {
        if ( this.urlProrroga === 'reabastecimiento' ) {
            this.inputContrato = false;
        } else {
            this.inputContrato = true;
            this.urlProrroga = 'alquiler';
        }
    }

    getCliente () {
        this.network.callSecureService(
            this.API.user.clientes + '/' + this.idCliente,
            'GET',
            null )
            .subscribe((response: any) => {
                // console.log(response);
                if (response.Estatus === 206) {
                    Swal('Oops', response.Mensaje, 'warning');
                } else {
                    this.cliente = response.Mensaje.cliente;
                    this.sucursalesUsuaio = [];
                    this.sucursalesUsuaio.push({
                        id: response.Mensaje.cliente.sucursalId,
                        nombre: response.Mensaje.cliente.sucursalNombre,
                    });
                    this.nombreC = response.Mensaje.cliente.nombre;
                    this.paternoC = response.Mensaje.cliente.paterno;
                    this.maternoC = response.Mensaje.cliente.materno;
                    this.rfc = response.Mensaje.cliente.rfc;
                    this.tipoCliente = response.Mensaje.cliente.tipo_cliente;
                    this.razonSocial = response.Mensaje.cliente.razonSocial;
                    this.nombreCompleto = this.nombreC + ' ' + this.paternoC + ' ' + this.maternoC;
                }
                if ( this.tipoCliente === 'MORAL' ) {
                    this.tipoClienteEnFormulario = 'Cliente de tipo Moral';
                } else if ( this.tipoCliente === 'FISICA' ) {
                    this.tipoClienteEnFormulario = 'Cliente de tipo Fisico';
                    document.getElementById('divRSocial').style.opacity =  '0';
                } else if ( this.tipoCliente === 'ESPECIAL' ) {
                    this.tipoClienteEnFormulario = 'Cliente Especial';
                }
            }, err => {
                console.log(err);
                Swal('Error ' + err.error.error.code, err.error.error.exception[0].message, 'error');
            }
        );
    }

    guardarAbastecimiento() {
        if ( this.urlProrroga === 'alquiler' ) {
            this.crearContrato();
        } else {
            this.abastecimientosCrear();
        }
    }

    crearContrato () {
        // Bandera utilizada para almacenar los documentos ya ingresados al sistema.
        let bandera = 0;
        let garantia = $('.archivoDocumento');
        // En el siguiente For, la bandera se va sumando para cumplir alguna confición
        for (const archivo of garantia) {
            // Cachamos el valor de undefined ...
            if ( typeof(archivo.files[0]) !== 'undefined'  ) {
                bandera = bandera + 1;
            }
        }

        if ($('#CONTRATO')[0].files.length === 0) {
            Swal('Falta Contrato', 'Por favor agrega el contrato primero', 'error');
            $('button').click(function() {
                $('html,body').animate({
                    scrollTop: $('#divDocumentoContrato').offset()},
                    'slow');
            });
            // window.scroll(0, 400);
            // Obtener documento: Orden de trabajo. Y la bandera (si existen más de dos documentos igual a 'true').
            // !$('#ORDENTRABAJO').val() ||
        } else if ( bandera <= 1 ) {
            Swal('Falta información', 'Falta alguna garantía', 'info');
        } else {
            if (this.contratoFolio !== '' && this.duracionServicio !== '' && this.fechaDeInicio !== '') {
                // Calendario
                this.fechaEnDataPicker = this.fechaDeInicio['formatted'];
                this.nuevaFecha = moment(this.fechaEnDataPicker['_i']).add(this.duracionServicio, 'days');
                // Objeto. propiedad de objeto(formatted)
                const formularioContrato: FormData = new FormData();
                this.loginLoader = true;

                formularioContrato.append('noContrato', this.contratoFolio);
                formularioContrato.append('fechaInicio', this.fechaEnDataPicker);
                formularioContrato.append('dias', this.duracionServicio);
                formularioContrato.append('obra', this.nombreObra);
                formularioContrato.append('fechaFin', this.nuevaFecha);
                // Al ser único elemento, utilizamos JQuery para poder agregar el documento al fromData.
                // utilizamos $('#(id<html>)'), cuando son varíos lo agregamos a la clase con (.). Cuando es un único elemento utilizamos #
                const fileUpload = $('#CONTRATO');
                formularioContrato.append(fileUpload[0].id, fileUpload[0].files[0]);

                this.network.callSecureService(
                    this.API.user.clientes + '/' + this.idCliente + '/' + this.API.user.contratos + '/' + this.API.user.crear,
                    'POST',
                    formularioContrato)
                    .subscribe((response: any) => {
                    // console.log(response);
                    this.loginLoader = false;
                    if ( response.Estatus !== 201 ) {
                        Swal('Error', response.Mensaje, 'error');
                        $('button').click(function() {
                            $('html,body').animate({
                                scrollTop: $('#fContrato').offset()},
                                'slow');
                        });
                        this.fFolioContrato = true;
                    } else {
                        this.abastecimientosCrear();
                    }
                }, err => {
                    this.loginLoader = false;
                    console.log(err);
                Swal('Error ' + err.error.error.code, err.error.error.exception[0].message, 'error');
                });
            } else {
                Swal('Error', 'Te falta el folio, el nombre de la obra, o la fecha del servicio ', 'error');
            }
        }
    }

    abastecimientosCrear() {
        // Bandera utilizada para almacenar los documentos ya ingresados al sistema.
        console.log(this.cotizacionId);
        if ( !this.cotizacionId ) {
            this.cotizacionId = 0;
        }
        console.log( this.cotizacionId );
        let bandera = 0;
        let garantia = $('.archivoDocumento');
        // En el siguiente For, la bandera se va sumando para cumplir alguna confición
        for (const archivo of garantia) {
            // Cachamos el valor de undefined ...
            if ( typeof(archivo.files[0]) !== 'undefined' ) {
                bandera = bandera + 1;
            }
        }
        // !$('#ORDENTRABAJO').val() ||
        if ( bandera <= 1 ) {
            Swal('Falta información', 'Falta alguna garantía', 'info');
        } else if ( this.duracionServicio === '' || this.fechaDeInicio === '' ) {
            Swal('Falta información', 'Indica la duración y la fecha', 'info');
        } else {
            this.arrayUrl = this.urlCompleta.split('/');
            this.concepto = this.arrayUrl.pop().toUpperCase();
            this.conceptoSpli = this.concepto.split(')')[0];
            // Calendario
            this.fechaEnDataPicker = this.fechaDeInicio['formatted'];
            this.nuevaFecha = moment(this.fechaEnDataPicker['_i']).add(this.duracionServicio, 'days');
            // .add(this.duracionServicio, 'days')
            // Objeto. propiedad de objeto(formatted)
            // console.log( this.fechaDeInicio['formatted'] );
            const documentosGarantias: FormData = new FormData();
            this.loginLoader = true;

            documentosGarantias.append('cotizacionId', this.cotizacionId);
            documentosGarantias.append('concepto', this.conceptoSpli);
            documentosGarantias.append('noContrato', this.contratoFolio);
            // Operador ternario utilizado para evitar la introducción de undefined.
            documentosGarantias.append('comentFactura', this.cliente.comentarioFACTURA ? this.cliente.comentarioFACTURA : '');
            documentosGarantias.append('comentPagare', this.cliente.comentarioPAGARE ? this.cliente.comentarioPAGARE : '');
            documentosGarantias.append('comentOrden', this.cliente.comentarioORDENTRABAJO ? this.cliente.comentarioORDENTRABAJO : '');
            documentosGarantias.append('comentPago', this.cliente.comentarioCOMPROBANTEPAGO ? this.cliente.comentarioCOMPROBANTEPAGO : '');
            documentosGarantias.append('comentAviso', this.cliente.comentarioAVISO ? this.cliente.comentarioAVISO : '');
            documentosGarantias.append('comentDomicilioAval', this.cliente.comentarioAVALDOMICILIO ? this.cliente.comentarioAVALDOMICILIO : '');
            documentosGarantias.append('comentOtro1', this.cliente.comentarioOTROUNO ? this.cliente.comentarioOTROUNO : '');
            documentosGarantias.append('comentOtro2', this.cliente.comentarioOTRODOS ? this.cliente.comentarioOTRODOS : '');

            documentosGarantias.append('fechaInicio', this.fechaDeInicio['formatted']);
            documentosGarantias.append('dias', this.duracionServicio);

            documentosGarantias.append('fechaFin', this.nuevaFecha.format());

            console.log(documentosGarantias);

            const fileUpload = $('.archivoDocumento');
            for (const archivo of fileUpload) {
                if (archivo.files.length > 0) {
                    documentosGarantias.append(archivo.id, archivo.files[0]);
                }
            }
            this.network.callSecureService(
                this.API.user.clientes + '/' + this.idCliente + '/' + this.API.user.contratos + '/' + this.contratoFolio + '/' + this.API.user.abastecimientos + '/' + this.API.user.crear,
                'POST',
                documentosGarantias)
                .subscribe((response: any) => {
                    console.log(response);
                    this.loginLoader = false;
                    if ( response.Estatus === 201 ) {
                        this.abastecimientoId = response.Mensaje.abastecimientoId;
                        console.log( this.abastecimientoId );
                        Swal('Correcto', 'Se creó el abastecimiento con éxito', 'success');
                        // == Targets de notificación ==
                        let nombreCliente;
                        this.tipoCliente === 'FISICA' ? nombreCliente = this.nombreC + ' ' + this.paternoC : nombreCliente = this.razonSocial;
                        let targets = response.Mensaje.notificacion;
                        targets.forEach(e => {
                            const target = e.target;
                            const id = e.id;
                            let notificacionString =  'El usuario ' + this.usuario.userName + ' ha generado abastecimiento para el cliente: ' + nombreCliente;
                            let url = 'verCliente/' + this.idCliente + '/contratos/' + this.contratoFolio + '/abastecimiento/' + this.abastecimientoId;
                            this.sendMessageTest(target, notificacionString, url, id);
                        });
                        // == Targets de notificación ==
                        this.ruta.navigate(['dashboard/verCliente', this.idCliente, 'contratos', this.contratoFolio, 'abastecimiento', this.abastecimientoId ]);
                    } else {
                    }
                }, err => {
                    console.log(err);
                    Swal('Error ' + err.error.error.code, err.error.error.exception[0].message, 'error');
                    this.loginLoader = false;
                }
            );
        }
    }

    folioNormal () {
        this.fFolioContrato = false;
    }

    public setInnerHtml(pdfurl: string) {
        this.innerHtml = this.sanitizer.bypassSecurityTrustHtml(
            "<object data='" + pdfurl + "' type='application/pdf' style='width:100%; height: 400px;'>" +
            'Object ' + pdfurl + ' failed' +
            '</object>');

        this.innerHtmlContrato = this.sanitizer.bypassSecurityTrustHtml(
            "<object data='" + pdfurl + "' type='application/pdf' style='width:100%; height: 400px;'>" +
            'Object ' + pdfurl + ' failed' +
            '</object>');
    }

    sendMessage(target, notificacionString, url) {
        let mensaje = {
            mensaje: notificacionString,
            usuario: this.usuario.userName,
            target: target,
            tipo: 'notificacion',
            url: url
        };
       this.chat.sendMsg(mensaje);
    }

    sendMessageTest(target, notificacionString, url, id) {
        let mensaje = {
          mensaje: notificacionString,
          usuario: this.usuario.userName,
          target: target,
          tipo: 'notificacion',
          url: url,
          id: id
        };
       this.chat.sendMsg(mensaje);
    }

}



// WEBPACK FOOTER //
// C:/xampp/htdocs/sm8-v1-front/src/app/_components/cliente/registrar-abastecimiento/registrar-abastecimiento.component.ts